import {
  detachLayoutProps,
  WSAvatarProps,
  WSElement,
  WSFlexBox,
  WSIcon,
  WSLabel,
  WSMarginProps
} from "@wingspanhq/fe-component-library";
import classNames from "classnames";
import React, { ReactNode, useEffect, useState } from "react";
import styles from "./styles.module.scss";

type Props = {
  avatarProps?: WSAvatarProps;
  title: string;
  subtitle?: string;
  children: ReactNode;
  isExpanded?: boolean;
  onClick?: () => void;
} & WSMarginProps;

export type CollapsibleItemHandle = {
  setExpanded: React.Dispatch<React.SetStateAction<boolean>>;
};

export const CollapsibleItem = React.forwardRef<CollapsibleItemHandle, Props>(
  (props, ref) => {
    const {
      avatarProps,
      title,
      subtitle,
      children,
      isExpanded = false,
      onClick,
      ...other
    } = props;
    const { layoutProps } = detachLayoutProps(other);
    const [expanded, setExpanded] = useState(isExpanded);

    useEffect(() => {
      // keep it open/close if done by the user
      // auto open if the prop is true
      if (isExpanded) {
        setExpanded(true);
      }
    }, [isExpanded]);

    const handleClick = () => {
      setExpanded(prev => !prev);
      onClick?.();
    };

    return (
      <WSElement
        {...layoutProps}
        className={classNames(styles.collapsibleItem, {
          [styles.expanded]: expanded
        })}
      >
        <WSFlexBox.CenterY
          wrap="nowrap"
          justify="space-between"
          p="XL"
          onClick={handleClick}
          alignItems="center"
          colorBackground="white"
        >
          <WSLabel
            avatar={avatarProps}
            secondaryText={title}
            helperText={subtitle}
          />

          <WSIcon name={expanded ? "caret-up" : "caret-down"} color="gray500" />
        </WSFlexBox.CenterY>
        {expanded && (
          <WSElement
            colorBackground="gray50"
            p="XL"
            className={styles.collapsibleContent}
          >
            {children}
          </WSElement>
        )}
      </WSElement>
    );
  }
);
